
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { LeadAccount } from "@/types/strategy-types";

export const useLeadAccountForm = (
  initialData?: LeadAccount,
  userRole?: string | null
) => {
  const [formData, setFormData] = useState<Omit<LeadAccount, 'id' | 'created_at' | 'updated_at'>>({
    external_id: initialData?.external_id || "",
    exchange: initialData?.exchange || "",
    strategy_provider_id: initialData?.strategy_provider_id || "",
    active: initialData?.active !== undefined ? initialData.active : true,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [providerId, setProviderId] = useState<string | null>(null);

  // Fetch provider ID for strategy providers
  useEffect(() => {
    const fetchProviderId = async () => {
      if (userRole === 'strategy_provider') {
        const { data: roleData } = await supabase
          .from('user_roles')
          .select('provider_id')
          .eq('user_id', (await supabase.auth.getSession()).data.session?.user.id)
          .single();

        if (roleData?.provider_id) {
          setProviderId(roleData.provider_id);
          setFormData(prev => ({
            ...prev,
            strategy_provider_id: roleData.provider_id
          }));
        }
      }
    };

    fetchProviderId();
  }, [userRole]);

  const handleChange = (field: keyof typeof formData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return {
    formData,
    setFormData,
    isSubmitting,
    setIsSubmitting,
    providerId,
    handleChange
  };
};
